import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BoardCard } from "@fry/boards/lib";
import { TextCardOptions } from "./text-card";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReactiveFormsModule, Validators } from "@angular/forms";
import { EasFormService, EasFieldControl, EasFieldType, EasFormGroup } from "../easform";

import { MaterialModule } from "@fry/components/material";
import { EasFormModule } from "../easform/easform.module";

@Component({
    selector: 'eas-text-card-settings',
    templateUrl: './text-card.settings.component.html',
    imports: [
    MaterialModule,
    EasFormModule,
    ReactiveFormsModule
],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCardSettingsComponent {

    dialogRef = inject(MatDialogRef<TextCardSettingsComponent>);
    data: { options: TextCardOptions, card: BoardCard } = inject(MAT_DIALOG_DATA);
    options = this.data.options;
    card = this.data.card;

    private formService = inject(EasFormService);
    private formFields: EasFieldControl[] = [
        {
            id: 'title',
            title: $localize `Title`,
            type: EasFieldType.Field,
            validators: [],
            widget: { type: 'string' },
        },
        {
            id: 'paragraph',
            title: $localize `Text`,
            type: EasFieldType.Field,
            validators: [Validators.required],
            widget: { type: 'wysiwyg' },
        }
    ];

    public form!: EasFormGroup;

    constructor() {
        this.form = this.formService.createForm(this.formFields, this.options);
    }

    ngOnInit() {
        //this.form = this.formService.createForm(this.formFields, this.options);
    }

    onCancel() {
        this.dialogRef.close();
    }

    onSave() {
        const value = this.form.getValue();
        const options: TextCardOptions = {
            title: value.title,
            paragraph: value.paragraph
        }
        this.dialogRef.close(options);
    }

}